module.exports = function() {
  return new Worker("/" + "download.worker.e2283bafc6215c9d8a80.js");
};